import { createDocument, getAllData } from "apis/customApiHandler";
import Spinner from "components/Spinner";
import { FaTrash } from "react-icons/fa";
import Model from "components/Modal";
import { Form, FormikProvider, useFormik } from "formik";
import useDebounce from "hooks/useDebounce";
import React, { Fragment, useCallback, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useQuery, useQueryClient } from "react-query";
import { useSelector } from "react-redux";
import { Button, Input } from "styled";
import { TD, TH } from "styled/table";
import checkPermission from "utils/checkPermission";
import permissions from "utils/permissionConstants";
import ReactSelect from "react-select";
import InputField from "components/formik/InputField";
import axios from "apis/axios";
import exportExcel from "utils/exportExcel";
import { IoMdArrowBack, IoMdArrowForward } from "react-icons/io";
import Delete from "components/tyres/Delete";

const AddTyre = () => {
  const [showAddmodel, setShowAddmodel] = useState(false);
  const [search, setSearch] = useState("");
  const currentUser = useSelector((state) => state.user.currentUser);
  const [showBulkUploadModel, setShowBulkUploadModel] = useState(false);
  const [page, setPage] = useState(1);
  const [selectedFleets, setSelectedFleets] = useState([]);
  const [selectedHubs, setSelectedHubs] = useState([]);
  const [fleetMap, setFleetMap] = useState({});
  const [tyres, setData] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const getData = async ()=>{
    setIsLoading(true)
    const dt = await getAllData("/tyre", {
      searchQuery: search,
      $or: [
        {isGrnTyre: false},
        {owner: "FLEET"}
      ],
      ...(selectedFleets?.includes("all")
        ? {
            fleets: null
          }
        : selectedFleets.length && {
            fleets: selectedFleets.map((fleet) => fleet).join(","),
          }),
      ...(selectedHubs?.includes("all")
        ? {
            hubs: null
          }
        : selectedHubs.length && {
            hubs: selectedHubs.map((hub) => hub).join(","),
          }),
      page: page,
      limit : 200,
    })

    //console.log(dt)
    setData(dt);
    setIsLoading(false)

  }

  useEffect(()=>{
    if((!selectedHubs.length && !search)){
      //console.log("")
    }else getData(page)
  }, [page])

  const { data: allFleets } = useQuery([`/customer-fleet`], () =>
    getAllData("/customer-fleet", {
      limit: 3000,
      page: 1,
    })
  );
  const { data: allHubs } = useQuery([`/customer-hub`], () =>
    getAllData("/customer-hub", {
      limit: 3000,
      page: 1,
    })
  );

  const getFleetOptions = useCallback(() => {
    if (allFleets && allFleets.data && allFleets.data.length) {
      return [
        {
          label: "All",
          value: "all",
        },
        {
          label: "Clear",
          value: "clear",
        },
        ...allFleets?.data?.map((fleet) => {
          return {
            value: fleet._id,
            label: fleet.fleetName,
          };
        }),
      ];
    }
  }, [allFleets]);

  const getHubOptions = useCallback(() => {
    if (allHubs && allHubs.data && allHubs.data.length) {
      return [
       ...selectedFleets?.length ? [{
          label: "All",
          value: "all",
        }]: [],
        ...selectedFleets?.length ? [{
          label: "Clear",
          value: "clear",
        }]: [],
        ...(selectedFleets?.includes("all") ? 
        allHubs?.data?.length &&
          allHubs?.data
            ?.map((hub) => {
              return {
                value: hub._id,
                label: hub.hubName,
              };
            }) : 
        allHubs?.data?.length &&
          allHubs?.data
            ?.filter((hub) => {
              const selectedFleetsVal = allFleets?.data?.filter((fleet) =>
                selectedFleets?.includes(fleet._id)
              );

              return selectedFleetsVal?.some(
                (fleet) => fleet.fleetCode === hub.fleetCode
              );
            })
            ?.map((hub) => {
              return {
                value: hub._id,
                label: hub.hubName,
              };
            })),
      ];
    }
  }, [allFleets, allHubs, selectedFleets]);

  return (
    <div>
      <div className="w-full px-8 flex justify-center items-center gap-4">
        <label className="w-full py-3">
          Select Fleets
          <ReactSelect  
            styles={{
              control: (base, state) => ({
                ...base,
                borderColor: "transparent",
                minWidth: "100%",
                "&:hover": {
                  borderColor: "rgb(34 197 94)",
                },
              }),
            }}
            className="shadow-md rounded-md py-1 mb-2"
            options={getFleetOptions()}
            value={
              selectedFleets &&
              selectedFleets?.map((fleet) => {
                return {
                  value: fleet,
                  label: getFleetOptions()?.find((item) => item?.value === fleet)
                    ?.label,
                };
              })
            }
            onChange={(value) => {
              let allValues = value?.map((item) => item.value);
              if(allValues?.includes("clear")){
                // console.log(allValues)
                setSelectedFleets([]);
                setSelectedHubs([]);
                return;
              }
              if(!selectedFleets?.includes("all") && allValues.includes("all")){
                setSelectedFleets(["all"]);
                return;
              }

              if (selectedFleets.includes("all")) {
                // console.log("first");
                // console.log(getFleetOptions())
                value = value.filter(item => item.value!== "all")
              }

              let selectedFleetsVal = allFleets?.data?.filter((fleet) =>
                value?.map((item) => item.value)?.includes(fleet._id)
              );

              let selectedHubsVal = allHubs?.data?.filter((hub) =>
                selectedHubs?.map((item) => item)?.includes(hub._id)
              );
              
              setSelectedHubs(
                selectedHubsVal
                  ?.filter((hub) =>
                    selectedFleetsVal?.find(
                      (fleet) => fleet.fleetCode === hub.fleetCode
                    )
                  )
                  .map((hub) => hub._id)
              );

              // console.log({allHubs, selectedHubs})
              
              setSelectedFleets(value.map((fleet) => fleet.value));
              }
          }
            name="fleets"
            isMulti = {true}
          />
        </label>
        <label className="w-full py-3">
          Select Hubs
          <ReactSelect
            styles={{
              control: (base, state) => ({
                ...base,
                borderColor: "transparent",
                minWidth: "100%",
                "&:hover": {
                  borderColor: "rgb(34 197 94)",
                },
              }),
            }}
            className="shadow-md rounded-md py-1 mb-2"
            options={getHubOptions()}
            value={
              selectedHubs &&
              selectedHubs?.map((hub) => {
                // console.log({hub})
                return {
                  value: hub,
                  label: getHubOptions()?.find((item) => item.value === hub)
                    ?.label,
                };
              })
            }
            onChange={(value) => {
              const allValues = value?.map((item) => item.value);
              // console.log({allValues})
              if(allValues.includes("clear")){
                setSelectedHubs([])
                return;
              }
              if (!selectedHubs?.includes("all") && allValues.includes("all")) {
                let selectedFleetCodes = allFleets?.data?.filter((fleet) =>
                  selectedFleets?.includes(fleet._id)
                )?.map(fleet=>fleet.fleetCode);

                const selectedHubsData = allHubs?.data?.filter(hub=> selectedFleetCodes?.includes(hub.fleetCode))

                const mp = fleetMap;
                selectedHubsData.map(hub=>{
                  if(selectedFleetCodes?.includes(hub.fleetCode)){
                  if(mp[hub.fleetCode] === undefined) mp[hub.fleetCode] = [];
                  mp[hub.fleetCode] = [...mp[hub.fleetCode], hub._id]
                }})

                setFleetMap(mp);
                setSelectedHubs(["all"])
              } 
              else {
                // console.log({value})
                value = value.filter(value => value.value!== "all")
                // console.log({value})
                let selectedFleetCodes = allFleets?.data?.filter((fleet) =>
                  selectedFleets?.includes(fleet._id)
                )?.map(fleet=>fleet.fleetCode);
                // console.log({allValues})
              
                const selectedHubsData = allHubs?.data?.filter(hub=> allValues?.includes(hub._id))
                const mp = {};
                selectedHubsData.map(hub=>{
                  mp[hub.fleetCode] = [];
                })

                selectedHubsData.map(hub=>{
                  if(selectedFleetCodes?.includes(hub.fleetCode)){
                  if(mp[hub.fleetCode] === undefined) mp[hub.fleetCode] = [];
                  mp[hub.fleetCode] = [...mp[hub.fleetCode], hub._id]
                }})

                setFleetMap(mp);                  
                setSelectedHubs(value.map((hub) => hub.value));
              }
            }}
            name="hubs"
            isMulti={true}
          />
        </label>
        
      </div>
      <div className="mx-10 my-2">
        <div className="mt-8 flex justify-start gap-6 items-center flex-wrap lg:flex-nowrap">
          <div className="relative w-full">
            <Input
              type="search"
              placeholder="Search Here"
              onChange={(e) => {
                setSearch(e.target.value);
              }}
            />
          </div>
          <Button type="button" disabled = {(!selectedHubs.length && !search)} bgPrimary onClick={()=>{; setPage(1); getData()}} >
            Search
          </Button>

          <Button
            className="!px-8 disabled:bg-gray-400"
            bgPrimary
            disabled={!checkPermission([permissions.manage_masters, permissions.manage_non_cpkm_tyres, permissions.manage_stencil_menu], currentUser)}
            onClick={() => setShowAddmodel(true)}
          >
            Add
          </Button>
          <Button
            className="!px-8 disabled:bg-gray-400 w-[230px] max-h-[42px]"
            bgPrimary
            disabled={!checkPermission([permissions.manage_masters, permissions.manage_non_cpkm_tyres, permissions.manage_stencil_menu], currentUser)}
            onClick={() => setShowBulkUploadModel(true)}
          >
            Bulk Upload
          </Button>
        </div>
      </div>
      {isLoading ? (
        <Spinner />
      ) : (
        <div className="flex flex-col m-2 lg:m-10">
          <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
              <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <TH scope="col">S.N.</TH>
                      <TH scope="col">Owner</TH>
                      <TH scope="col">Material No</TH>
                      <TH scope="col">Material Description</TH>
                      <TH scope="col">Company</TH>
                      <TH scope="col">Tyre Size</TH>
                      <TH scope="col">Original NSD</TH>
                      <TH scope="col">Stencil No</TH>
                      <TH scope="col">Fleet</TH>
                      <TH scope="col">Hub</TH>
                      <TH scope="col">Created By</TH>
                      <TH scope="col">Created At</TH>
                      <TH scope="col">Actions</TH>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {tyres?.data &&
                      tyres?.data.map((item, index) => (
                        <ViewList data={item} key={item?._id} index={(page-1)*200 + index} />
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          {tyres &&
            tyres.paginate &&
            tyres.paginate.totalData &&  (
              <div className="container mx-auto flex justify-center items-center gap-2 py-5">
                <Button
                  onClick={() => setPage((p) => Math.max(p - 1, 1))}
                  disabled={page === 1}
                  className="disabled:pointer-events-none disabled:opacity-70 px-0 "
                  primary
                >
                  <div className="flex gap-1 items-center">
                    <IoMdArrowBack />
                    Prev Page
                  </div>
                </Button>
                <span className="text-gray-600 px-4">{`showing: ${
                  (page - 1) * 200 + 1
                } - ${Math.min(tyres.paginate.totalData, page * 200)} of ${tyres.paginate.totalData}`}</span>

                <Button
                  onClick={() =>
                    setPage((p) => Math.min(p + 1, tyres?.paginate?.totalPage))
                  }
                  disabled={page === tyres?.paginate?.totalPage }
                  className="disabled:pointer-events-none disabled:opacity-70 px-0 "
                  primary
                >
                  <div className="flex gap-1 items-center">
                    Next Page
                    <IoMdArrowForward />
                  </div>
                </Button>
              </div>
            )}
        </div>
      )}
      {showAddmodel && <Add handleClick={() => setShowAddmodel(false)} />}
      {showBulkUploadModel && (
        <BulkUpload handleClick={() => setShowBulkUploadModel(false)} />
      )}
    </div>
  );
};

export default AddTyre;

const ViewList = ({ data, index }) => {
  console.log('data--',data)
  const currentUser = useSelector((state) => state.user.currentUser);
  const [showDeleteModel, setShowDeleteModel] = useState(false);
  return (
    <Fragment>
      <tr key={data._id} className={`${index % 2 !== 0 && "bg-gray-100"}`}>
        <TD>{index + 1}</TD>
        <TD>{data?.product?.materialNo ? "JK" : "FLEET"}</TD>
        <TD>
          {data?.product?.materialNo || data?.productMaster?.materialNo || "-"}
        </TD>
        <TD>
          {(data?.product?.materialNo
            ? data.product.productName
            : data?.productMaster?.productName) || "-"}
        </TD>
        <TD>{data?.productMaster?.company?.name || data?.product?.companyName || "-"}</TD>
        <TD>{data?.productMaster?.tyreSize?.name || data?.product?.tyreSize || "-"}</TD>
        <TD>{data?.productMaster?.originalNSD || data?.product?.originalNSD || "-"}</TD>
        <TD>{data?.stencilNo}</TD>
        <TD>{data?.fleet?.fleetName}</TD>
        <TD>{data?.hub?.hubName}</TD>
        <TD>
          {data.createdBy && data.createdBy.name ? data.createdBy.name : "---"}
        </TD>
        <TD>{new Date(data.createdAt).toLocaleDateString("en-GB").replace(/\//g, '-')}</TD>
        <TD>
          {data?.status!== "FITTED" && checkPermission([permissions.delete_tyre], currentUser) ? (
            <div className="">
              <button
                onClick={() => {
                  setShowDeleteModel(true);
                }}
                className="p-2  m-1 rounded-md bg-red-500 hover:bg-red-600 text-white"
              >
                <FaTrash />
              </button>
            </div>
          ) : (
            <p>----</p>
          )}
        </TD>
      </tr>
      {showDeleteModel && (
        <Delete
          data={data}
          handleClick={() => {
            setShowDeleteModel(false);
          }}
        />
      )}
    </Fragment>
  );
};

const Add = ({ handleClick }) => {
  const queryClient = useQueryClient();
  const { data: allFleets } = useQuery([`/customer-fleet`], () =>
    getAllData("/customer-fleet", {
      limit: 3000,
      page: 1,
    })
  );
  const { data: allHubs } = useQuery([`/customer-hub`], () =>
    getAllData("/customer-hub", {
      limit: 3000,
      page: 1,
    })
  );

  const { data: allProductMaster } = useQuery([`/product-master`], () =>
    getAllData("/product-master", {
      limit: 10000,
      page: 1,
    })
  );

  const { data: allProducts } = useQuery([`/product`], () =>
    getAllData("/product", {
      limit: 10000,
      page: 1,
    })
  );

  const formik = useFormik({
    initialValues: {
      stencilNo: "",
      fleet: "",
      hub: "",
      status: "",
      productMaster: "",
      owner: "FLEET",
      tyreType: "",
      contractType: "NON CPKM",
    },
    onSubmit: async (values) => {
      try {
        // let data;
        // if (values.owner === "JK") {
        //   data = await getAllData("/validate/stencil", {
        //     dealerCode: values.hub,
        //     stencilNumber: values.stencilNo,
        //   });
        //   if (data) {
        //     data = await createDocument("tyre", {
        //       ...values,
        //       isFromSuppliedByChalan: false,
        //     });
        //     if (data) {
        //       toast.success("Successfully saved");
        //       queryClient.invalidateQueries("tyres");
        //       handleClick();
        //     }
        //   }
        // } else {
        //   data = await createDocument("tyre", {
        //     ...values,
        //     isFromSuppliedByChalan: false,
        //   });
        //   if (data) {
        //     toast.success("Successfully saved");
        //     queryClient.invalidateQueries("tyres");
        //     handleClick();
        //   }
        // }
        const data = await createDocument("tyre", {
          ...values,
          isFromSuppliedByChalan: false,
        });
        if (data) {
          toast.success("Successfully saved");
          queryClient.invalidateQueries("tyres");
          handleClick();
        }
      } catch (error) {
        return null;
      }
    },

    validate: (values) => {
      let errors = {};
      if (!values.stencilNo) errors.stencilNo = "Required";
      if (!values.fleet) errors.fleet = "Required";
      if (!values.hub) errors.hub = "Required";
      if (!values.status) errors.status = "Required";
      if (!values.productMaster) errors.productMaster = "Required";
      if (!values.owner) errors.owner = "Required";
      if (!values.tyreType) errors.tyreType = "Required";
      return errors;
    },
  });

  const getFleetOptions = useCallback(() => {
    if (allFleets && allFleets.data && allFleets.data.length) {
      return [
        ...allFleets?.data?.map((fleet) => {
          return {
            value: fleet._id,
            label: fleet.fleetName,
          };
        }),
      ];
    }
  }, [allFleets]);

  const getHubOptions = useCallback(() => {
    if (allHubs && allHubs.data && allHubs.data.length) {
      const selectedFleet = allFleets?.data?.find((fleet) => {
        return fleet._id === formik.values.fleet;
      });
      return [
        ...allHubs?.data
          ?.filter((hub) => hub.fleetCode === selectedFleet?.fleetCode)
          .map((hub) => {
            return {
              value: hub._id,
              label: hub.hubName,
            };
          }),
      ];
    }
  }, [allHubs, allFleets, formik.values.fleet]);

  const getProductMasterOptions = useCallback(() => {
    let data = [];
    if (
      allProductMaster &&
      allProductMaster.data &&
      allProductMaster.data.length
    ) {
      data = [
        ...data,
        ...allProductMaster?.data?.map((prd) => {
          return {
            value: prd._id,
            label: prd.materialNo,
          };
        }),
      ];
    }

    return data;
  }, [allProductMaster]);

  const getAllProductsOptions = useCallback(() => {
    let data = [];

    if (allProducts && allProducts.data && allProducts.data.length) {
      data = [
        ...data,
        ...allProducts?.data?.map((prd) => {
          return {
            value: prd._id,
            label: prd.materialNo +  "/" + prd.productName,
          };
        }),
      ];
    }

    return data;
  }, [allProducts]);

  const tyreStatus = [
    { label: "ITM", value: "READY_TO_FIT_OUT" },
    { label: "SCRAP", value: "SCRAP" },
    { label: "REPAIR", value: "REPAIR" },
    { label: "CASING", value: "CASING" },
    { label: "REUSE", value: "REUSE" },
    { label: "RETREAD", value: "RETREAD" },
  ];

  const owners = ["JK", "FLEET"];
  const tyreTypes = ["ITM", "RTD1", "RTD2", "RTD3"];
  const currentUser = useSelector((state) => state.user.currentUser);

  return (
    <Model
      handleClick={handleClick}
      title={"Add Tyre"}
      className="w-[700px] h-[620px]"
    >
      <FormikProvider value={formik}>
        <Form className="px-5 text-gray-700 font-medium text-base grid  lg:gap-x-14 gap-y-5 grid-flow-row grid-cols-1 lg:grid-cols-2 w-full">
          <label className="py-3">
            Select Owner
            {<span className="text-red-500 required-dot">*</span>}
            <ReactSelect
              styles={{
                menuList: (styles) => {
                  return {
                    ...styles,
                    maxHeight: 166,
                  };
                },
              }}
              options={owners.map((status) => ({
                value: status,
                label: status,
              }))}
              value={{
                value: formik.values.owner,
                label: owners.find((d) => d === formik.values.owner),
              }}
              onChange={(value) => {
                formik.setFieldValue("owner", value.value);
                formik.setFieldValue("productMaster", "");
              }}
              name="owner"
              placeholder="Select Owner"
              isDisabled = {!["SUPER_ADMIN"].includes(currentUser?.userRole?.name)}
            />
            {formik.touched.fleet && formik.errors.fleet ? (
              <p className="text-red-500 font-normal">*{formik.errors.fleet}</p>
            ) : null}
          </label>
          <label className="py-3">
            Select Fleet
            {<span className="text-red-500 required-dot">*</span>}
            <ReactSelect
              styles={{
                menuList: (styles) => {
                  return {
                    ...styles,
                    maxHeight: 166,
                  };
                },
              }}
              options={getFleetOptions()}
              value={{
                value: formik.values.fleet,
                label: getFleetOptions()?.find(
                  (fleet) => fleet.value === formik.values.fleet
                )?.label,
              }}
              onChange={(value) => {
                formik.setFieldValue("fleet", value.value);
              }}
              name="fleet"
              placeholder="Select Fleet"
            />
            {formik.touched.fleet && formik.errors.fleet ? (
              <p className="text-red-500 font-normal">*{formik.errors.fleet}</p>
            ) : null}
          </label>

          <label className="py-3">
            Select Hub
            {<span className="text-red-500 required-dot">*</span>}
            <ReactSelect
              styles={{
                menuList: (styles) => {
                  return {
                    ...styles,
                    maxHeight: 166,
                  };
                },
              }}
              options={getHubOptions()}
              value={{
                value: formik.values.hub,
                label: getHubOptions()?.find(
                  (hub) => hub.value === formik.values.hub
                )?.label,
              }}
              onChange={(value) => {
                formik.setFieldValue("hub", value.value);
              }}
              name="hub"
              placeholder="Select Hub"
            />
            {formik.touched.hub && formik.errors.hub ? (
              <p className="text-red-500 font-normal">*{formik.errors.hub}</p>
            ) : null}
          </label>

          {(formik.values.owner === "JK" ||
            formik.values.owner === "FLEET") && (
            <label className="py-3">
              Select Material
              {<span className="text-red-500 required-dot">*</span>}
              <ReactSelect
                styles={{
                  menuList: (styles) => {
                    return {
                      ...styles,
                      maxHeight: 166,
                    };
                  },
                }}
                options={
                  formik.values.owner === "JK"
                    ? getAllProductsOptions()
                    : getProductMasterOptions()
                }
                value={{
                  value: formik.values.productMaster,
                  label:
                    formik.values.owner === "JK"
                      ? getAllProductsOptions()?.find(
                          (item) => item.value === formik.values.productMaster
                        )?.label
                      : getProductMasterOptions()?.find(
                          (item) => item.value === formik.values.productMaster
                        )?.label,
                }}
                onChange={(value) => {
                  formik.setFieldValue("productMaster", value.value);
                }}
                name="productMaster"
              />
              {formik.touched.productMaster && formik.errors.productMaster ? (
                <p className="text-red-500 font-normal">
                  *{formik.errors.productMaster}
                </p>
              ) : null}
            </label>
          )}
          <InputField
            type="text"
            required={true}
            label="Stencil No"
            name="stencilNo"
          />
          <label className="py-3">
            Tyre Type
            {<span className="text-red-500 required-dot">*</span>}
            <ReactSelect
              styles={{
                menuList: (styles) => {
                  return {
                    ...styles,
                    maxHeight: 166,
                  };
                },
              }}
              options={tyreTypes.map((status) => ({
                value: status,
                label: status,
              }))}
              value={{
                value: formik.values.tyreType,
                label: tyreTypes.find((d) => d === formik.values.tyreType),
              }}
              onChange={(value) => {
                if(value.value != "ITM" && formik.values.status !== "RETREAD") formik.setFieldValue("status", null)
                formik.setFieldValue("tyreType", value.value);
              }}
              name="tyreType"
              placeholder="Select Tyre Type"
            />
            {formik.touched.fleet && formik.errors.fleet ? (
              <p className="text-red-500 font-normal">*{formik.errors.fleet}</p>
            ) : null}
          </label>
          <label className="py-3">
            Tyre Status
            {<span className="text-red-500 required-dot">*</span>}
            <ReactSelect
              styles={{
                menuList: (styles) => {
                  return {
                    ...styles,
                    maxHeight: 166,
                  };
                },
              }}
              isDisabled = {!formik.values.tyreType}
              options={formik.values.tyreType ? 
                /RTD/.test(formik.values.tyreType) ? tyreStatus.filter(option => option.value != "READY_TO_FIT_OUT") : tyreStatus.filter(option => option.value!= "RETREAD")
              : []}
              value={{
                value: formik.values.status,
                label: tyreStatus.find((d) => d.value === formik.values.status)?.label,
              }}
              onChange={(event) => {
                formik.setFieldValue("status", event.value);
              }}
              name="status"
              placeholder="Select Tyre Status"
            />
            {formik.touched.status && formik.errors.status ? (
              <p className="text-red-500 font-normal">
                *{formik.errors.status}
              </p>
            ) : null}
          </label>
        </Form>
        <div className="px-5 flex justify-end items-center gap-4 pt-28 flex-wrap sm:w-full">
          <Button bgSecondary onClick={handleClick}>
            Cancel
          </Button>
          <Button type="button" bgPrimary onClick={formik.handleSubmit}>
            Save Changes
          </Button>
        </div>
      </FormikProvider>
    </Model>
  );
};

const BulkUpload = ({ handleClick }) => {
  const [file, setFile] = React.useState("");
  const [loading, setIsLoading] = useState(false)
  const queryClient = useQueryClient();
  const [correctData, setCorrectData] = React.useState([]);
  const [incorrectData, setIncorrectData] = React.useState([]);
  const [errorDump, setErrorDump] = React.useState([]);

  let downloadSampleExcelLink =
    "https://jk-fleet.s3.ap-south-1.amazonaws.com/1673591483631-STENCIL_UPLOAD_SAMPLE_FILE.xlsx";

  const handleFileChange = async (e) => {
    try {
      e.preventDefault();
      let file = e.target.files[0];
      let allowedFileTypes = [
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-excel",
        "text/csv",
      ];
      let regEx = new RegExp(
        allowedFileTypes.map((type) => `^.*${type}$`).join("|")
      );
      if (regEx.test(file.type)) {
        setFile(file);
      }
      if (!regEx.test(file.type)) {
        toast.error("please upload only valid excel or csv file");
        //clear file input
        e.target.value = "";
      }
    } catch (error) {
      //console.log(error);
    }
  };

  const handleSubmit = async () => {
    try {
      let formData = new FormData();
      formData.append("file", file);
      setIsLoading(true);
      const response = await axios({
        method: "post",
        url: "/bulk-upload/tyres",
        data: formData,
      });
      const data = await response.data;
      setIsLoading(false)
      setCorrectData(data?.uploadedData);
      setIncorrectData(data?.errors);
      setErrorDump(data?.errorTyres)
      toast.success("Successfully saved");
      queryClient.invalidateQueries("/bulk-upload/tyres");
      // handleClick();
    } catch (error) {
      //console.log(error);
      setIsLoading(false)
      toast.error(
        error?.response?.data?.message
          ? error?.response?.data?.message
          : "Something went wrong"
      );
      setCorrectData(error?.response?.data?.uploadedData);
      setIncorrectData(error?.response?.data?.errors);
    }
  };

  const handleCorrectDataExport = () => {
    if (correctData?.length > 0) {
      exportExcel(correctData, "correctData");
    } else {
      toast.error("No data to export");
    }
  };

  const handleIncorrectDataExport = () => {
    if (errorDump?.length > 0) {
      exportExcel(errorDump.map((dt)=>(
      {
        "fleetCode": dt.fleetCode,
        "hubCode": dt.hubCode,
        "material description": dt["material description"],
        "materialNo": dt.materialNo,
        "stencilNo": dt.stencilNo,
        "brand": dt.brand
      }
    )
    ), "incorrectData");
    } else {
      toast.error("No data to export");
    }
  };

  return (
    <Model
      handleClick={handleClick}
      title={"Bulk Upload"}
      className="max-w-2xl"
    >
      <div className="w-full p-8 flex flex-col justify-start items-start">
        <Button
          onClick={() => window.open(downloadSampleExcelLink, "_blank")}
          bgSecondary
        >
          Download Sample Excel File
        </Button>
        <Input
          type="file"
          className="shadow-sm mt-8"
          name="excelFile"
          onChange={handleFileChange}
        />
        <div className="flex gap-4">
          <Button className="mt-8" onClick={handleSubmit} bgPrimary>
            Upload
          </Button>
          <Button className="mt-8" onClick={handleClick} bgSecondary>
            Cancel
          </Button>
        </div>

        <div className="">
          {loading ? <div className= "my-4"> Uploading </div> : ""}
        {correctData?.length > 0 && (
          <div>
            <div
              className="border-b-2 border-green-500 text-green-500 cursor-pointer mt-5 mb-2"
              // onClick={handleCorrectDataExport}
            >
              Uploaded Data
            </div>
            {correctData.map(dt=>{
              return <div> {dt} </div>;
            })}
          </div>
            
          )}
          {incorrectData?.length > 0 && (
            <div>
            <div
              className="  border-b-2 border-red-500 text-red-500 cursor-pointer mt-10 mb-2"
              // onClick={handleIncorrectDataExport}
            >
              Incorrect Data
            </div>
            {incorrectData.map(dt=>{
              return <div> {dt} </div>;
            })}
            </div>
          )}
          {/* {correctData?.length > 0 && (
            <span
              className="border-b-2 border-green-500 text-green-500 cursor-pointer"
              onClick={handleCorrectDataExport}
            >
              Download Correct Data
            </span>
          )} */}
          {errorDump?.length > 0 && (
            <span
              className="  border-b-2 border-red-500 text-red-500 cursor-pointer"
              onClick={handleIncorrectDataExport}
            >
              Download Incorrect Data
            </span>
          )}
        </div>
      </div>
    </Model>
  );
};
